import {initHeaderMenu} from "./header";
import {initNestedMenu} from "./menu";
import {initSliders} from "./sliders";
import {initAccordions} from "./accordion";
import {initLazyload} from "./zlazyload";
import {initLightBox} from "./lightbox";
import {initLoadMorePosts} from "./load-posts";
import {initDropdown} from "./dropdown";
import {initTableOfContent} from "./toc";
import {initDocSearch} from "./doc-search";
import {initContactForm} from "./contact/contact";
import {initLoginPage} from "./login";
import {initLicense} from "./license";
import {initTooltip} from "./tooltip";
import {initDomainManager} from "./domain-manager";
import {initRepeaterFields} from "./repeater-field";
import {initAddon} from "./addon";
import {initDashboard} from "./dashbaord";
import {initAddStyleToIframes} from "./iframe";
import {initUpgradeLicense} from "./upgrade-license";

const init = () => {
    initHeaderMenu()
    initNestedMenu()
    initSliders()
    initAccordions()
    initLazyload()
    initLightBox()
    initLoadMorePosts()
    initDropdown()
    initTableOfContent()
    initDocSearch()
    initContactForm()
    initLoginPage()
    initLicense()
    initTooltip()
    initDomainManager()
    initRepeaterFields()
    initAddon()
    initDashboard()
    initAddStyleToIframes()
    initUpgradeLicense()
}

document.addEventListener('DOMContentLoaded', () => {
    init()
});
